/*
 * Auto embed Tableau figures in divs w/ class "tableauPlaceholder"
 */

var vizs = [];
buildTableau(vizs);
window.tableau_vizs = vizs;

const fixVizParentSize = (viz, widthOverride, heightOverride) => {
    const frame = viz._impl.$2;
    // no frame found?
    if (!frame) {
        console.warn('Frame not found for viz');
        console.log(viz);
        return;
    }
    frame.parentNode.style.setProperty('width', widthOverride ?? frame.style.width);
    frame.parentNode.style.setProperty('height', heightOverride ?? frame.style.height);
}

window.addEventListener('resize', async () => {
    if ( !await _debounce_resize() ) {
        return;
    }
    for ( const viz of tableau_vizs ) {
        viz.refreshSize();
        // fix parent size
        fixVizParentSize(viz);
    }
});
$(document).on('click', '.tableauPlaceholder .open', (event) => {
    event.preventDefault();
    // lock html
    document.getElementsByTagName('html')[0].classList.add('locked');
    const parent = event.target.closest('div');
    parent.classList.add('expanded');
    const viz = vizs[parent.attributes.getNamedItem('data-viz-id').value];
    viz.refreshSize();
    fixVizParentSize(viz);

    return false;
});
$(document).on('click', '.tableauPlaceholder .close', (event) => {
    event.preventDefault();
    document.getElementsByTagName('html')[0].classList.remove('locked');
    const parent = event.target.closest('div');
    parent.classList.remove('expanded');
    const viz = vizs[parent.attributes.getNamedItem('data-viz-id').value];
    // have to set width manually before refreshing the size here
    fixVizParentSize(viz, '100%', 'auto');
    viz.refreshSize();

    return false;
});

/*
 * Embed tableau figure in divs
 *
 * @param vizs: empty array, will be filled with tableau.Viz instances
 */
function buildTableau(vizs) {
    var i = 0;
    for (const divElement of document.getElementsByClassName('tableauPlaceholder')) {
        // Strip any whitespace from div
        divElement.innerHTML = '';

        // Tableau has it's own animated loader, but that can take some time to
        // get going. Worse, the tableauPlaceholder div is very short, so the
        // text jumps around on the page as the tableau figures get loaded. Use
        // a custom loading img to fill in the empty space until the actual
        // tableau loader shows.
        // TODO - use different size loading gifs for diff figures
        let image_url = '';

        try {
            image_url = document.querySelector('meta[name="tableau-loader-image"]')
                .content;
        } catch (e) {
            console.error('Unable to find tableau-loader-image meta');
        }

        if (image_url !== '') {
            console.log(`Setting tableau loader to ${image_url}`);
            const img = document.createElement('img');
            img.src = image_url;
            img.className = "tableauLoader";
            img.id = `tableauLoader${i}`;
            divElement.parentNode.insertBefore(img, divElement);
        }

        var url = _getAttribute(divElement, 'url');
        const dataName = _getAttribute(divElement, 'data-name');
        const filter = _getAttribute(divElement, 'data-filter');

        if (url == '' && dataName != '') {
            url = "https://public.tableau.com/views/" + dataName;
            console.log('Warning: url missing for', dataName);
        }

        var viz;
        const id = i;
        var options = {
            onFirstInteractive: function () {
                $('iframe').attr('sandbox', 'allow-downloads');
                // TODO - provide a legitimate title for each iframe for accessibility
                $('iframe').attr('title', `ATB Tableau figure of ${url}`);
            },

            // At onFirstVizSizeKnown, the iframe appears and the actual tableau
            // loader is visible. Remove the ATB tableau loader since we no
            // longer need it.
            onFirstVizSizeKnown: function () {
                if (image_url !== '') {
                    const loader = document.getElementById(`tableauLoader${id}`);
                    loader.parentNode.removeChild(loader);
                    const parent = this.$2.parentNode.parentNode;
                    const viz_id = document.createAttribute('data-viz-id');
                    viz_id.value = id;
                    parent.attributes.setNamedItem(viz_id);
                    // add expand button
                    const expand_button = document.createElement('a');
                    expand_button.href = '#';
                    expand_button.classList.add('open');
                    expand_button.title = 'Expand table view';
                    expand_button.innerHTML = '<i class="fa fa-expand" aria-hidden="true"></i>';
                    parent.appendChild(expand_button);
                    // add close button
                    const close_button = document.createElement('a');
                    close_button.href = '#';
                    close_button.classList.add('close');
                    close_button.title = 'Close expanded table view';
                    close_button.innerHTML = '&#x2715;';
                    parent.appendChild(close_button);
                }
            },
        };
        // "real" container"
        const iframeContainer = document.createElement('div');

        // @hack
        const coverReset = document.createElement('div');
        coverReset.id = 'hide-reset';
        coverReset.style = 'position: absolute;right: 231px;height: 27px;width: 42px;background: #f3f3f3;bottom: 0;';
        iframeContainer.appendChild(coverReset)

        divElement.appendChild(iframeContainer)

        viz = new tableau.Viz(iframeContainer, url, options);
        viz.id = id;
        viz.url = url;
        vizs.push(viz);
        i++;
    }
}

let resize_timeout;
async function _debounce_resize() {
    return new Promise(resolve => {
        clearTimeout(resize_timeout);
        resize_timeout = setTimeout(() => resolve(true), 250);
    });
}

function _getAttribute(element, key) {
    const attribute = element.attributes.getNamedItem(key);
    if (!attribute) {
        return '';
    }
    return attribute.value;
}
